module.exports = __webpack_public_path__ + "family_chalkboard-geometric_1.jpg";